module.exports = __webpack_public_path__ + "static/method-desktop-header-0f24c5bdd766a581e30acb60808e0f9f.png";